module.exports = __webpack_public_path__ + "static/media/delete.07082c40.svg";